<template>
  <div class="bigbox" v-loading="loading">
    <div class="form">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="年份:">
          <el-select clearable @change="handelchange" v-model="formInline.year" placeholder="" size="small"
            style="width: 100px; margin-right: 20px">
            <el-option v-for="item in yearoptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省|直辖市:">
          <el-select clearable @change="handelchange" v-model="provinceobj" placeholder="不限" size="small"
            style="width: 100px; margin-right: 20px" value-key="id">
            <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科别类型:">
          <el-select clearable @change="disciplineTypeChange" v-model="formInline.disciplineType" placeholder="不限"
            size="small" style="width: 100px; margin-right: 20px">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录取批次：">
          <el-select clearable @change="batchChange" v-model="formInline.admitBatch" placeholder="不限" size="small"
            style="width: 100px; margin-right: 20px">
            <el-option v-for="item in batchoptions" :key="item.batchId" :label="item.batch" :value="item.batch">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否已关联高校:">
          <el-select clearable v-model="formInline.hasRelate" placeholder="请选择" size="small"
            style="width: 100px; margin-right: 20px">
            <el-option v-for="item in optionsgl" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="高校省份:">
          <el-select clearable v-model="formInline.collegeProvince" placeholder="不限" size="small"
            style="width: 100px; margin-right: 20px" value-key="id">
            <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="高校:">
          <el-input v-model="formInline.keyWord" placeholder="请输入高校名称或代码" size="small"
            style="width: 180px; margin-right: 20px" clearable></el-input>
        </el-form-item>
        <el-form-item label="院校特性：">
          <el-select clearable multiple v-model="collegeCharacter" placeholder="不限" @change="changecollegeCharacter"
            size="small" style="width: 200px; margin-right: 20px">
            <el-option v-for="item in collegeCharacteroptions" :key="item.value" :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报考要求类型:">
          <el-select clearable v-model="formInline.requiredType" placeholder="不限" size="small"
            style="width: 100px; margin-right: 20px">
            <el-option v-for="item in bktype" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选考科目:">
          <el-select clearable placeholder="不限" size="small" multiple v-model="formInline.disciplines"
            style="width: 200px; margin-right: 20px">
            <el-option v-for="item in xkkmList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分段:">
          <el-input v-model="formInline.scoreMin" placeholder="最低分" size="small" style="width: 85px" clearable>
          </el-input>
          -
          <el-input v-model="formInline.scoreMax" placeholder="最高分" size="small" style="width: 85px; margin-right: 20px"
            clearable></el-input>
        </el-form-item>
        <el-form-item label="位次:">
          <el-input v-model="formInline.accumulateMin" placeholder="最低位" size="small" style="width: 85px" clearable>
          </el-input>
          -
          <el-input v-model="formInline.accumulateMax" placeholder="最高位" size="small"
            style="width: 85px; margin-right: 20px" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="pagepageadmission">搜索</el-button>
          <el-button size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <el-table :stripe="true" size="mini" :data="tableData" border :height="tableHeigth" style="width: 100%"
        :header-cell-style="{ 'text-align': 'center', 'font-size': '14px', 'padding': '0px' }" :cell-style="cellStyle"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="year" label="年份" width="60"> </el-table-column>
        <!-- <el-table-column prop="collegeCode" label="高校代码" width="80"> -->
        <!-- </el-table-column> -->
        <!-- <el-table-column label="院校名称" width="180">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="showschool(scope.row)"
              class="maxlength"
              >{{ scope.row.collegeName }}</el-button
            >
          </template>
        </el-table-column> -->
        <el-table-column label="专业组代码" width="100">
          <template slot-scope="scope">
            <div>{{ scope.row.specialtyNames }}</div>
          </template>
        </el-table-column>
        <el-table-column label="专业组名称" min-width="180">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="showschool(scope.row)" class="maxlength">{{
                scope.row.specialtyOptions
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="specialtyName" label="包含专业" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="选考科目要求" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
            <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="collegeCity" label="所在城市" width="80" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="collegeCharacter" label="特性" width="140">
          <template slot-scope="scope">
            <span v-if="
              scope.row.collegeCharacter &&
              scope.row.collegeCharacter.includes('2')
            ">985
            </span>
            <span v-if="
              scope.row.collegeCharacter &&
              scope.row.collegeCharacter.includes('1')
            ">211
            </span>
            <span v-if="
              scope.row.collegeCharacter &&
              scope.row.collegeCharacter.includes('3')
            ">双一流</span>
            <span v-if="!scope.row.collegeCharacter">{{ filterRunType(scope.row.collegeRunType) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="province"
          label="省|直辖市"
          width="90"
          :show-overflow-tooltip="true"
        >
        </el-table-column> -->
        <!-- <el-table-column label="科别类型" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.disciplineType == 4">历史类</div>
            <div v-if="scope.row.disciplineType == 3">物理类</div>
            <div v-if="scope.row.disciplineType == 2">文科</div>
            <div v-if="scope.row.disciplineType == 1">理科</div>
            <div v-if="scope.row.disciplineType == 0">不分文理</div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="admitBatch" label="录取批次" width="100">
        </el-table-column> -->
        <el-table-column prop="scoreLine" label="省控线" width="65">
        </el-table-column>
        <el-table-column prop="scoreHighest" label="最高分" width="65">
        </el-table-column>
        <el-table-column prop="scoreLowest" label="最低分" width="65">
        </el-table-column>
        <el-table-column prop="accumulateLowest" label="最低位次" width="80">
        </el-table-column>
        <el-table-column prop="socreDisparity" label="分差" width="50">
        </el-table-column>
        <el-table-column prop="planNum" label="计划数" width="65">
        </el-table-column>
        <el-table-column prop="planNumLast" label="上年计划数" width="95">
        </el-table-column>
        <el-table-column prop="actualNum" label="实际数" width="65">
        </el-table-column>
        <el-table-column label="隐藏" width="50">
          <template slot-scope="scope">
            <div v-if="scope.row.isHidden == 0">否</div>
            <div v-if="scope.row.isHidden == 1">是</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope" v-if="scope.row.admissionCollegeId">
            <el-button @click="handleClick(scope.row.admissionCollegeId)" type="text" style="font-size: 14px"
              v-permission="'900301'">编辑</el-button>
            <el-button type="text" @click="del(scope.row.admissionCollegeId)" style="color: #f56c6c; font-size: 14px"
              v-permission="'900304'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="button">
<!--        <el-button size="small" type="primary" v-permission="'900302'" @click="showSynchronousInclusionSpecialty()">同步包含专业</el-button>-->
        <el-button type="warning" size="small" @click="setHidden(1)" v-permission="'900302'">设为不可见</el-button>
        <el-button type="success" size="small" @click="setHidden(0)" v-permission="'900302'">设为可见</el-button>
        <el-button size="small" type="danger" @click="delets" v-permission="'900304'">删除</el-button>
        <el-button size="small" type="primary" @click="Export" v-permission="'900303'">导出</el-button>
        <el-button type="primary" size="small" @click="handleClick()" v-permission="'900301'">新增</el-button>
        <el-upload class="upload1" action="/com/had-login/admission/admission-college/importExcel"
          :headers="uploadheaders"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          :show-file-list="false" :on-progress="uploading" :on-success="importSuccess" v-permission="'900303'">
          <el-button type="primary" size="small">导入</el-button>
        </el-upload>
        <el-button type="primary" size="small" style="margin-left: 20px" v-permission="'900303'">
          <a :href="`${path}excel/gklqsj.xlsx`" download="高考专业组录取数据模板.xlsx" style="color: #fff">下载模板</a>
        </el-button>
      </div>
    </div>

    <div class="pagination">
      <div style="font-size: 14px; color: #333333; padding-left: 10px">
        当前为第{{ formInline.current }}页/ 总共{{ totalPages }}页，总记录数为{{
            total
        }}条
      </div>

      <el-pagination background layout="prev, pager, next" :total="total" @current-change="handleChange"
        :current-page.sync="formInline.current" :page-size="formInline.size">
      </el-pagination>
    </div>
    <!-- 学校 -->
    <el-dialog :title="formschool.specialtyOptions" :visible.sync="dialogTableVisible" width="80%">
      <el-table :data="gridData" style="width: 100%;" height="500px"
        :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
        :cell-style="{ 'text-align': 'center', 'font-size': '14px' }" :stripe="true" size="mini" border>
        <el-table-column prop="year" label="年份" width="100">
        </el-table-column>
        <el-table-column label="专业组代码" width="100">
          <template slot-scope="scope">
            <div>{{ scope.row.specialtyNames }}</div>
          </template>
        </el-table-column>
        <el-table-column label="专业组">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="showspeciality(scope.row)" class="maxlength">{{
                scope.row.specialtyOptions
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="specialtyName" label="包含专业" width="120" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column prop="collegeCode" label="高校代码" width="100">
        </el-table-column> -->
        <!-- <el-table-column label="院校名称" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-button
              style="font-size: 14px"
              type="text"
              @click="showspeciality(scope.row)"
              >{{ scope.row.collegeName }}</el-button
            >
          </template>
        </el-table-column> -->

        <el-table-column prop="province" label="省|直辖市" width="120">
        </el-table-column>
        <el-table-column label="科别类型" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.disciplineType == 4">历史类</div>
            <div v-if="scope.row.disciplineType == 3">物理类</div>
            <div v-if="scope.row.disciplineType == 2">文科</div>
            <div v-if="scope.row.disciplineType == 1">理科</div>
            <div v-if="scope.row.disciplineType == 0">不分文理</div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="admitBatch" label="录取批次" width="120">
        </el-table-column> -->
        <el-table-column prop="scoreLine" label="省控线" width="80">
        </el-table-column>
        <el-table-column prop="scoreHighest" label="最高分" width="80">
        </el-table-column>
        <el-table-column prop="scoreLowest" label="最低分" width="80">
        </el-table-column>
        <el-table-column prop="accumulateLowest" label="最低位次" width="80">
        </el-table-column>
        <el-table-column prop="socreDisparity" label="分差" width="80">
        </el-table-column>
        <el-table-column prop="planNum" label="计划数" width="80">
        </el-table-column>
        <el-table-column prop="planNumLast" label="上年计划数" width="100">
        </el-table-column>
        <el-table-column prop="actualNum" label="实际数" width="80">
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="total1" @current-change="handleChange1"
        :current-page.sync="formschool.current" :page-size="formschool.size">
      </el-pagination>
    </el-dialog>

    <!-- 专业 -->
    <el-dialog :title="formschool.specialtyOptions" :visible.sync="dialogTableVisible1" width="70%">
      <el-form :inline="true" :model="formspeciality" class="demo-form-inline">
        <el-form-item label="年份:">
          <el-select @change="handelchange2" v-model="formspeciality.year" size="small"
            style="width: 100px; margin-right: 20px">
            <el-option v-for="item in yearoptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省|直辖市:">
          <el-select @change="handelchange2" v-model="formspeciality.province" placeholder="不限" size="small"
            style="width: 160px; margin-right: 20px" value-key="id">
            <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科别类型:">
          <el-select clearable v-model="formspeciality.disciplineType" placeholder="不限" size="small"
            style="width: 100px; margin-right: 20px">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录取批次：">
          <el-select clearable v-model="formspeciality.admitBatch" placeholder="不限" size="small"
            style="width: 160px; margin-right: 20px">
            <el-option v-for="item in batchoptions1" :key="item.batch" :label="item.batch" :value="item.batch">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业名称：">
          <el-input size="small" placeholder="专业名称或代码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="showspeciality()">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="gridDataspeciality"
                style="width: 100%"
                height="500px"
        :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
        :cell-style="{ 'text-align': 'center', 'font-size': '14px' }" :stripe="true" size="mini" border>
        <el-table-column prop="year" label="年份" width="100">
        </el-table-column>
        <el-table-column prop="specialtyNames" label="专业组代码" width="100">
        </el-table-column>
        <el-table-column prop="specialtyOptions" label="专业组名称" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="specialtyCode" label="专业代码" width="100">
        </el-table-column>
        <el-table-column prop="specialtyName" label="专业名称" width="130" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="province" label="省|直辖市" width="120">
        </el-table-column>
        <el-table-column label="科别类型" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.disciplineType == 4">历史类</div>
            <div v-if="scope.row.disciplineType == 3">物理类</div>
            <div v-if="scope.row.disciplineType == 2">文科</div>
            <div v-if="scope.row.disciplineType == 1">理科</div>
            <div v-if="scope.row.disciplineType == 0">不分文理</div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="admitBatch" label="录取批次" width="120">
        </el-table-column> -->
        <el-table-column prop="scoreHighest" label="最高分" width="80">
        </el-table-column>
        <el-table-column prop="scoreLowest" label="最低分" width="80">
        </el-table-column>
        <el-table-column prop="accumulateLowest" label="最低位次" width="80">
        </el-table-column>
        <el-table-column prop="admitNum" label="录取人数" width="80">
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 多数据操作 -->
    <el-dialog title="请选择操作数据" :visible.sync="centerDialogVisible" width="400px" center>
      <div class="centerdiv">
        <el-radio v-model="radio" :label="1">当前勾选数据</el-radio>
        <el-radio v-model="radio" :label="2">当前条件数据</el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="chooseset" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="同步包含专业" :visible.sync="includeDialogVisible" width="450px">
      <el-form  label-width="100px">
        <el-form-item label="年份:">
          <el-select v-model="synchronousParams.year" placeholder="请选择" size="small" style="width: 240px; margin-right: 20px">
          <el-option v-for="item in yearoptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="省份:">
          <el-select  v-model="synchronousParams.provinceId"  placeholder="不限" size="small"
                      style="width: 240px; margin-right: 20px" clearable @change="synchronousProvinceChange">
            <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="includeDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="synchronousInclusionSpecialty" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { isflag } from "@/util/isflag.js";
import axios from "@/util/request";
import lpyMixin from "@/mixin/lpyMixin";
import { getProvinceList } from "@/api/index.js";
import {
  getProvincePage,
  getOneProvince,
  synchronousAdmissionInclusionSpecialty,
} from "@/api/systemManagement.js";
import { deleteBatchcollege } from "@/api/collegeEntranceExamination.js";
import {
  pagepageadmission,
  deletesadmission,
  setHidden,
  pagespecialty,
} from "@/api/collegeEntranceExamination.js";
export default {
  mixins: [lpyMixin],
  data() {
    return {
      synchronousParams: {
        year: new Date().getFullYear(),
        provinceId: "",
        provinceName: "",
      },
      includeDialogVisible: false,
      bktype: [
        { label: "不提科目要求", value: 0 },
        { label: "任选一门报考", value: 1 },
        { label: "均报考", value: 2 },
      ],
      xkkmList: [
        { label: "物理", value: "物理" },
        { label: "化学", value: "化学" },
        { label: "生物", value: "生物" },
        { label: "政治", value: "政治" },
        { label: "历史", value: "历史" },
        { label: "地理", value: "地理" },
      ],
      tableHeightSubtract: 400,
      cellStyle: {
        "text-align": "center",
        "font-size": "14px",
        visibility: "hidden",
      },
      centerDialogVisible: false,
      total1: 0,
      total: 0,
      totalPages: 1,
      radio: 1,
      optionsgl: [
        { label: "是", value: 1 },
        { label: "否", value: 0 },
      ],
      gridDataspeciality: [],
      dialogTableVisible1: false,
      formspeciality: { size: 500 },
      uploadheaders: {
        sessionId: sessionStorage.getItem("sessionId") || "",
      },
      loading: false,
      yearoptions: [],
      collegeCharacteroptions: [
        { label: "211", value: "1" },
        { label: "985", value: "2" },
        { label: "双一流", value: "3" },
        // { label: "公办", value: "5" },
        // { label: "民办", value: "4" },
      ],
      path: process.env.BASE_URL,
      options1: [
        { label: "不分文理", value: 0 },
        { label: "理科", value: 1 },
        { label: "文科", value: 2 },
        { label: "物理类", value: 3 },
        { label: "历史类", value: 4 },
      ], //科别
      formInline: {
        size: 500,
        current: 1,
        year: "",
        isOptions: 1,
        province: {},
        collegeCharacter: "",
        disciplineType: null,
        admitBatch: "",
      },
      input: "",
      dialogTableVisible: false,
      value: "",
      provinceList: [],
      tableData: [],
      dialogVisible: false,
      id: "",
      year: "",
      provinceobj: {},
      batchoptions: [],
      ids: [],
      batchoptions1: [],
      batchoptions2: [],
      schooldata: {},
      formschool: {
        size: 500,
        year: "",
        isOptions: 1,
        current: 1,
        province: {},
        disciplineType: 0,
        keyWord: "",
        admitBatch: "",
      },
      gridData: [],
      set: -1,
      disabled: true,
      collegeCharacter: [],
      lastDisciplineType: 0,
      lastBatch: "",
    };
  },
  mounted() {
    this.getyearsoptions();
    this.getProvinceList();
    for (var i = 0; i < 500; i++) {
      this.tableData.push({});
    }
  },
  methods: {
    filterRunType(data) {
      switch (data) {
        case 0:
          return '全部';
        case 1:
          return '公办';
        case 2:
          return '民办';
        case 3:
          return '其他';
        default:
          return ''
      }
    },
    showSynchronousInclusionSpecialty() {
      this.includeDialogVisible = true;
    },

    synchronousProvinceChange(val){
      let provinceList = this.provinceList.filter(item => item.id === val)
      if (provinceList && provinceList.length > 0){
        this.synchronousParams.provinceName = provinceList[0].name
      } else {
        this.synchronousParams.provinceName = ""
      }
    },

    synchronousInclusionSpecialty() {
      let message = "";
      if (this.synchronousParams.provinceId){
        message = `确认同步${this.synchronousParams.provinceName}${this.synchronousParams.year}年的包含专业吗？`
      } else {
        message = `确认同步${this.synchronousParams.year}年的包含专业吗？`
      }

      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.includeDialogVisible = false;
        this.$message({
          message: "正在后台同步数据，请耐心等待",
          type: "success",
        });
        synchronousAdmissionInclusionSpecialty(this.synchronousParams).then((res) => {
          if (res.code == 1) {
            this.$message({
              message: "同步成功",
              type: "success",
            });
          }
        });
      });
    },
    matchRequiredType(requiredType) {
      switch (requiredType) {
        case 0:
          return "不提科目要求";
        case 1:
          return "任选一门报考：";
        case 2:
          return "均报考：";
      }
    },
    changecollegeCharacter(val) {
      console.log(val, "val");
      this.formInline.collegeCharacter = val.join(",");
    },
    changeOptions() {
      this.pagepageadmission();
    },
    // 跳页
    handleChange(page) {
      console.log(page);
      this.formInline.current = page;
      this.pagepageadmission();
    },
    // 跳页
    handleChange1(page) {
      console.log(page);
      this.formschool.current = page;
      this.showschool();
    },
    //获取录取批次
    handelchange1() {
      this.batchoptions2 = [];
      getProvincePage({
        year: this.formschool.year,
        areaProvinceId: this.formschool.province.id,
      }).then((res) => {
        console.log(res, "res");
        let data = res.data || {};
        let arr = data.records || [];
        if (arr.length > 0 && arr[0].batchs) {
          this.batchoptions2 = arr[0].batchs || [];
        }
        if (this.batchoptions2.length > 0) {
          this.formschool.admitBatch = this.batchoptions2[0].batch;
          this.batchoptions2.forEach((item) => {
            if (item.strBatchType == "本科批") {
              this.formschool.admitBatch = item.batch;
              return;
            }
          });
        }
      });
    },
    //获取录取批次
    handelchange2() {
      this.batchoptions1 = [];
      getProvincePage({
        year: this.formspeciality.year,
        areaProvinceId: this.formspeciality.province.id,
      }).then((res) => {
        console.log(res, "res");
        let data = res.data || {};
        let arr = data.records || [];
        if (arr.length > 0 && arr[0].batchs) {
          this.batchoptions1 = arr[0].batchs || [];
        }
        if (this.batchoptions1.length > 0) {
          this.formschool.admitBatch = this.batchoptions1[0].batch;
          this.batchoptions1.forEach((item) => {
            if (item.strBatchType == "本科批") {
              this.formschool.admitBatch = item.batch;
              return;
            }
          });
        }
      });
    },
    //显示学校
    showschool(data) {
      console.log(data, "学校");
      if (data) {
        this.schooldata = data;
        this.formschool.year = null;
        this.formschool.disciplineType = data.disciplineType;
        this.formschool.admitBatch = data.admitBatch;
        this.formschool.province = {
          id: this.schooldata.provinceId,
          name: this.schooldata.province,
        };
      }

      this.formschool.specialtyOptions = this.schooldata.specialtyOptions;
      pagepageadmission(this.formschool).then((res) => {
        console.log(res, "res");
        let data = res.data || {};
        this.total1 = data.total;
        this.totalPages = data.pages;
        this.gridData = data.records || [];

        this.dialogTableVisible = true;
      });
    },
    //显示专业
    showspeciality(data) {
      if (data) {
        this.formspeciality.year = data.year;
        this.formspeciality.admitBatch = data.admitBatch;
        this.formspeciality.disciplineType = data.disciplineType;
        this.formspeciality.province = {
          name: data.province,
          id: data.provinceId,
        };
        this.formspeciality.specialtyOptions = data.specialtyOptions;
      }
      pagespecialty(this.formspeciality).then((res) => {
        if (res.code == 1) {
          let data = res.data || {};
          this.gridDataspeciality = data.records || [];
          this.dialogTableVisible1 = true;
        }
      });
    },
    handleSelectionChange(val) {
      this.ids = [];
      console.log(val, "val");
      val.forEach((item) => {
        if (item.admissionCollegeId) {
          this.ids.push(item.admissionCollegeId);
        }
      });
      if (val.length == this.ids.length && val.length > 0) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    //批量操作
    chooseset() {
      let setform = {};
      if (this.radio === 1) {
        if (this.ids.length == 0) {
          this.$message.error("当前无勾选数据");
          return;
        }
        setform = { idList: this.ids };
      }
      if (this.radio === 2) {
        setform = this.formInline;
      }
      if (this.set == 3) {
        if (this.radio == 1) {
          setform.type = 1;
          this.$confirm(
            "确定要删除当前勾选的共" + this.ids.length + "条数据吗",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              this.batchDeletion(setform);
            })
            .catch(() => { });
        }
        if (this.radio == 2) {
          setform.type = 2;
          this.formInline.size = 1;
          pagepageadmission(this.formInline).then((res) => {
            if (res.code == 1) {
              this.formInline.size = 500;
              let totalCount = res.data.total;
              this.$confirm(
                "确定要删除当前条件下共" + totalCount + "条数据吗",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              )
                .then(() => {
                  this.batchDeletion(setform);
                })
                .catch(() => { });
            }
          });
        }
      }
      if (this.set == 1 || this.set === 0) {
        setHidden({ status: this.set, ...setform }).then((res) => {
          if (res.code == 1) {
            this.pagepageadmission();
            this.$message({
              message: "设置成功",
              type: "success",
            });
            this.centerDialogVisible = false;
          }
        });
      }
    },
    /**
     * 调用批量删除接口
     */
    batchDeletion(setform) {
      deleteBatchcollege(setform).then((res) => {
        if (res.code == 1) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.pagepageadmission();
          this.centerDialogVisible = false;
        }
      });
    },
    //批量删除
    delets() {
      this.centerDialogVisible = true;
      this.set = 3;
    },
    Export() {
      let data = this.formInline;
      axios({
        method: "post",
        url: "/com/had-login/admission/admission-college/exportExcel",
        data: data,
        responseType: "blob",
      })
        .then((res) => {
          const elink = document.createElement("a");
          elink.download = "高考录取数据列表.xls"; //定义表格名称，后缀是文件格式
          elink.style.display = "none";
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          });
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //设为隐藏
    setHidden(status) {
      this.centerDialogVisible = true;
      this.set = status;
    },
    reset() {
      this.formInline = { size: 500, current: 1, isOptions: 1 };
      this.formInline.year = this.year;
    },
    //获取年份
    getyearsoptions() {
      let date = new Date();
      let year = date.getFullYear();
      this.synchronousParams.year = year
      this.year = year;
      this.formInline.year = year;
      console.log(year, 111);
      for (let i = 0; i < 10; i++) {
        this.yearoptions.push({ label: year - i, value: year - i });
      }
      // this.pagepageadmission();
    },
    //获取录取批次
    handelchange() {
      this.batchoptions = [];
      this.formInline.disciplineType = null;
      this.formInline.admitBatch = null;
      if (this.formInline.year && this.provinceobj.id) {
        // getProvincePage({
        //   year: this.formInline.year,
        //   areaProvinceId: this.provinceobj.id,
        // }).then((res) => {
        //   console.log(res, "res");
        //   if (res.code == 1) {
        //     let data = res.data || {};
        //     let arr = data.records || [];
        //     if (arr.length > 0 && arr[0].batchs) {
        //       this.batchoptions = arr[0].batchs || [];
        //     }
        //   }
        // });
        getOneProvince({
          year: this.formInline.year,
          areaProvinceId: this.provinceobj.id,
        }).then((res) => {
          if (res.code == 1) {
            let data = res.data;
            this.batchoptions = data.batchs || [];
            if (data.pattern == 3) {
              this.options1 = [
                { label: "理科", value: 1 },
                { label: "文科", value: 2 },
              ];
            }
            if (data.pattern == 2) {
              this.options1 = [
                { label: "物理类", value: 3 },
                { label: "历史类", value: 4 },
              ];
            }
            if (data.pattern == 1) {
              this.options1 = [{ label: "不分文理", value: 0 }];
            }
          }

          //判断上次科别类型和批次是否存在
          this.options1.forEach((item) => {
            if (item.value == this.lastDisciplineType) {
              this.formInline.disciplineType = item.value;
            }
          });

          this.batchoptions.forEach((item) => {
            if (item.batch == this.lastBatch) {
              this.formInline.admitBatch = item.batch;
            }
          });
        });
      } else {
        this.options1 = [
          { label: "不分文理", value: 0 },
          { label: "理科", value: 1 },
          { label: "文科", value: 2 },
          { label: "物理类", value: 3 },
          { label: "历史类", value: 4 },
        ];
      }
    },
    disciplineTypeChange(value) {
      this.lastDisciplineType = value;
    },

    batchChange(value) {
      this.lastBatch = value;
    },
    //获取省份
    getProvinceList() {
      getProvinceList().then((res) => {
        this.provinceList = res.data;
      });
    },
    uploading() {
      this.loading = true;
    },
    importSuccess(res) {
      this.loading = false;
      if (res.code === 1) {
        this.$message.success("导入成功")
      } else {
        this.open(res.msg);
      }
    },
    open(data) {
      this.$alert(data, "错误", {
        confirmButtonText: "确定",
        callback: (action) => { },
      });
    },
    //获取列表
    pagepageadmission() {
      if (!this.provinceobj.id) {
        this.$message({
          message: "请选择省|直辖市",
          type: "warning",
        });
        return;
      }
      if (!isflag(this.formInline.disciplineType)) {
        this.$message({
          message: "科目类型",
          type: "warning",
        });
        return;
      }
      if (!this.formInline.collegeProvince) {
        this.formInline.collegeProvince = null;
      }
      this.formInline.province = this.provinceobj || {};

      pagepageadmission(this.formInline).then((res) => {
        if (res.code == 1) {
          (this.cellStyle.visibility = "visible"), console.log(res, "res");
          let data = res.data || {};
          this.total = data.total;
          this.tableData = data.records || [];
        }
      });
    },
    handleClick(id) {
      if (id) {
        this.$router.push({
          path: "/newCollegeEntranceExaminationAdmissionData1",
          query: { id: id },
        });
        this.$store.commit("addbreadcrumb", {
          title: "编辑高校专业组录取数据",
          path: "/newCollegeEntranceExaminationAdmissionData1",
          value: { id: id },
        });
      } else {
        this.$router.push("/newCollegeEntranceExaminationAdmissionData1");
        // let breadcrumb = this.$store.state.breadcrumb;
        // if (breadcrumb.filter((item) => item.title == "新增高考录取数据").length == 0) {
        //   this.$store.commit("addbreadcrumb", {
        //     title: "新增高考录取数据",
        //     path: "/newCollegeEntranceExaminationAdmissionData",
        //     value: {},
        //   });
        // }
      }
    },
    del(id) {
      this.id = id;

      this.$confirm("是否删除此条高校录取数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deletesadmission();
        })
        .catch(() => { });
    },
    deletesadmission() {
      deletesadmission({ admissionCollegeIds: this.id }).then((res) => {
        if (res.code == 1) {
          this.pagepageadmission();
          this.dialogVisible = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bigbox {
  padding: 20px 20px 0px;

  .form {
    /deep/.el-form-item {
      margin-bottom: 12px !important;
    }
  }

  .table {
    margin-top: 30px;
    position: relative;

    .mask {
      position: absolute;
      width: 100%;
      height: 564px;
      top: 36px;
      left: 0px;
      background-color: rgba(255, 255, 255, 1);
      z-index: 99999999;
    }
  }

  span[class^="span"] {
    display: inline-block;
    // padding: 3px 15px;
    height: 20px;
    line-height: 20px;
    width: 50px;
    text-align: center;
    border-radius: 3px;
    margin-right: 10px;
  }

  .span1 {
    background-color: #fff9e0;
    color: #ef9a70;
  }

  .span2 {
    background-color: #e0faff;
    color: #56c1d6;
  }

  .span3 {
    background-color: #e0ffe0;
    color: #65e365;
  }

  .button {
    position: absolute;
    top: -40px;
    right: 0px;
  }

  .centerdiv {
    margin-left: 40px;
  }

  /deep/.maxlength {
    display: -webkit-box !important;

    -webkit-box-orient: vertical !important;

    -webkit-line-clamp: 2 !important;
    overflow: hidden !important;
    font-size: 14px !important;
  }

  /deep/.upload1 {
    display: inline-block;
    margin-left: 10px;
  }

  .pagination {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
  }
}
</style>
